import React from 'react';
import { useBrandingColors } from '../../hooks/useBrandingColors';
import AdminStatistics from '../AdminStatistics';

interface StatisticsCardProps {
  onBackToSearch: () => void;
  onOpenAdminPanel: () => void;
  onOpenActivity: () => void;
}

const StatisticsCard: React.FC<StatisticsCardProps> = ({
  onBackToSearch,
  onOpenAdminPanel,
  onOpenActivity
}) => {
  const colors = useBrandingColors();
  return (
    <div className="bg-[#f5f6f1] rounded-xl p-[24px] min-h-[calc(100vh-280px)] w-full">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-semibold text-gray-900">Статистика</h2>
        <button
          onClick={onOpenAdminPanel}
          className="transition-colors text-[15px] font-medium"
          style={{ color: colors.primary }}
          onMouseEnter={(e) => (e.currentTarget.style.color = colors.primaryHover)}
          onMouseLeave={(e) => (e.currentTarget.style.color = colors.primary)}
        >
          ← Назад к админпанели
        </button>
      </div>
      
      <div className="flex-1">
        <AdminStatistics />
      </div>
      
      <div className="mt-6 flex gap-2">
        <button 
          onClick={onOpenActivity}
                      className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-xl hover:bg-green-700"
        >
          Активность
        </button>
      </div>
    </div>
  );
};

export default StatisticsCard;
